import React from "react";
import Box from "@mui/material/Box";
import { images } from "../../Images/Svg";

const { reject, approveSuccess, flag } = images;

const approvalActionPopper = [
  {
    icon: approveSuccess,
    label: "Approve",
  },
  {
    icon: flag,
    label: "Flag",
  },
  {
    icon: reject,
    label: "Reject",
  },
];

const ApprovalActionPopper = ({ onClick = () => {} }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-around",
        padding: "0.9rem 0.5rem",
      }}
    >
      {approvalActionPopper?.map((item) => {
        return (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={(e) => onClick(e, item?.label)}
          >
            <Box>
              {item?.icon ? <img src={item?.icon} alt={item?.label} /> : ""}
            </Box>
            <Box>{item?.label}</Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default ApprovalActionPopper;
